module.exports = __webpack_public_path__ + "media/images/burger-black-32e59fed17ff8d63e2a86440db72dec1.png";